<template>
  <div
    class="drawing-list"
    :class="{ 'empty-list': drawings.length === 0 }"
    elevation="2"
  >
    <template v-if="drawings.length > 0">
      <div class="drawing-container">
        <div
          v-for="(url, index) in drawings"
          :key="index"
          :class="{ selected: selectedStates[index] }"
          class="drawing-item"
          elevation="1"
          @click="handleItemClick(index, $event)"
        >
          <div class="image-container">
            <v-img
              :src="url"
              :width="800"
              cover
              class="drawing-image"
            />
            
            <div class="controls" @click.stop>
              <v-checkbox
                :model-value="selectedStates[index]"
                @update:model-value="(e) => $emit('toggle-select', index, e)"
                color="flat"
                hide-details
                class="white-checkbox"
                true-icon="mdi-checkbox-marked"
                false-icon="mdi-checkbox-blank-outline"
              />
              
              <div v-if="showActions !== false" class="action-buttons">
                <!-- <v-btn
                  class="replace-button"
                  variant="flat"
                  size="small"
                  prepend-icon="mdi-cloud-upload"
                  @click.stop="$emit('replace', index)"
                >
                  替换
                </v-btn> -->
                
                <v-btn
                  class="delete-button"
                  variant="flat"
                  size="small"
                  prepend-icon="mdi-delete"
                  @click.stop="$emit('delete', index)"
                >
                  删除
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    
    <template v-else>
      <div class="empty-state">
        <v-img
          :src="noImageSrc"
          width="200"
          height="200"
          class="mb-4"
        />
        <v-text class="text-h6 text-grey">
          暂无图纸
        </v-text>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import noImageSrc from '@/assets/noImg.jpg'

const props = defineProps<{
  drawings: string[]
  selectedStates: { [key: number]: boolean }
  showActions?: boolean
}>()

const emit = defineEmits<{
  (e: 'toggle-select', index: number, checked: boolean): void
  (e: 'image-click', index: number): void
  (e: 'delete', index: number): void
  (e: 'replace', index: number): void
}>()

// 处理图片点击
const handleItemClick = (index: number, event: MouseEvent) => {
  // 如果是点击控制区域，不处理
  if ((event.target as HTMLElement).closest('.controls')) {
    return
  }

  // 如果按住 Ctrl 键，切换选中状态
  if (event.ctrlKey) {
    emit('toggle-select', index, !props.selectedStates[index])
    return
  }

  // 否则预览图片
  emit('image-click', index)
}
</script>

<style scoped>
.drawing-list {
  padding: 24px;
  height: 100%;
}

.drawing-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

.drawing-item {
  width: 100%;
  height: 100%;
  max-width: 800px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 3px solid transparent;
  overflow: hidden;
  border-radius: 8px;
}

.drawing-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.drawing-item.selected {
  border-color: #E34C65;
  border-width: 4px;
}

.drawing-item.selected .drawing-image {
  opacity: 0.95;
}

.image-container {
  position: relative;
  width: 100%;
  background-color: #f5f5f5;
}

.controls {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5), transparent);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.drawing-item:hover .controls {
  opacity: 1;
}

.white-checkbox {
  :deep(.v-label) {
    color: white;
  }
  :deep(.v-selection-control__input) {
    color: white;
  }
  :deep(.v-selection-control__wrapper) {
    opacity: 0.7;
  }
  :deep(.v-selection-control--dirty .v-selection-control__wrapper) {
    opacity: 1;
  }
  :deep(.mdi-checkbox-blank-outline) {
    color: white;
    opacity: 0.7;
  }
  :deep(.mdi-checkbox-marked) {
    color: #E34C65;
    opacity: 1;
  }
}

.action-buttons {
  display: flex;
  gap: 8px;
  transform: translateY(-10px);
  transition: transform 0.2s ease;
}

.drawing-item:hover .action-buttons {
  transform: translateY(0);
}

.replace-button,
.delete-button {
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
}
</style>
